<template lang="html">
  <TFinderLayout>
    <template #sidebar>
      <TText
        color="grey darken-1"
        value="COMPANY.manage"
        font_weight="400"
      />
      <!-- CompanyManage -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanyManage'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'CompanyManage'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="company" />
        <TText class="color-white-09" value="Manage" />
      </TFlex>
      <!-- CompanyProjects -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanyProjects'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'CompanyProjects'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="construction-crane" />
        <TText class="color-white-09" value="Projects" />
      </TFlex>
      <!-- ProjectRoleTemplates (CompanySettings) -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanySettings'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'CompanySettings'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="identity" />
        <TText class="color-white-09" value="Project Role Templates" />
      </TFlex>
      <!-- IFCImportStrategies -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanyIFCImportStrategies'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'CompanyIFCImportStrategies'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="project-structure" />
        <TText class="color-white-09" value="IFC Import Strategies" />
      </TFlex>
      <!-- CompanyEmailEndings -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanyEmailEndings'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'CompanyEmailEndings'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="email" />
        <TText class="color-white-09" value="Mail Endings" />
      </TFlex>
      <!-- CompanyEntraIdMapper -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanyEntraIdMappers'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'CompanyEntraIdMappers'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="key-modern" />
        <TText class="color-white-09" value="Entra Id Mappers" />
      </TFlex>
      <!-- CompanyClients -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanyClients'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'CompanyClients'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="person-small" />
        <TText class="color-white-09" value="Company Clients" />
      </TFlex>
      <!-- ProcoreClients -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'ProcoreClients'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ProcoreClients'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TIcon class="mr-1" medium name="person-add" />
        <TText class="color-white-09" value="Procore Clients" />
      </TFlex>
      <!-- CompanyStatistics -->
      <!-- <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'CompanyStatistics'
          })"
        >
        <div
          v-if="$route.matched[2] && $route.matched[2].name === 'CompanyStatistics'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <TText class="color-white-09" :value="Statistics" />
      </TFlex> -->

      <v-spacer v-if="hasBusinessPermission('Delete Business')" />
      <v-btn
        v-if="hasBusinessPermission('Delete Business')"
        color="red"
        disabled
        style="font-size: 13px;"
        >
        {{$t('Company.Home.CancelCompany')}}
      </v-btn>


    </template>
    <template #actionbar>
      <div v-if="$route.matched[1] && $route.matched[1].name === 'CompanyEmailEndings'">
        List of Endings
      </div>
      <div v-if="$route.matched[1] && $route.matched[1].name === 'CompanyEntraIdMappers'">
        List of Entra Id Mappings
      </div>
    </template>
    <template #content>
      <router-view/>
    </template>
  </TFinderLayout>
</template>

<script>
import { TFinderLayoutMixin } from '@/mixins/TFinderLayout.mixin.js'
import { mapGetters } from 'vuex';
import store from '@/store/index';
export default {
  name: 'CompanyHome',
  mixins: [TFinderLayoutMixin],
  beforeRouteEnter (to, from, next) {
      let current_user = store.getters['Auth/getUser'];
      if (current_user.business) {
        let promises = [
          store.dispatch('Ultra/requestUObject', {
            url: [
              { businesses: current_user.business.id },
              { showWithEntitiesNormalized: '' }
            ]
          })
        ];

        Promise.all(promises)
        .then(res => {
          next(res);
        });

      } else {
        next({ name: 'UserHome'});
      }
    },
  created(){

  },
  computed: {
    ...mapGetters('Business', [
      'getBusiness',
      'hasBusinessPermission'
    ])
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
</style>
